import { render, staticRenderFns } from "./SaveVideoModal.vue?vue&type=template&id=20cb1052&scoped=true&"
import script from "./SaveVideoModal.vue?vue&type=script&lang=ts&"
export * from "./SaveVideoModal.vue?vue&type=script&lang=ts&"
import style0 from "./SaveVideoModal.vue?vue&type=style&index=0&id=20cb1052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cb1052",
  null
  
)

export default component.exports